import { useEffect, useState } from 'react';

interface IUseKeyPressOptions {
  disabled?: boolean;
  onDown?: (event: KeyboardEvent) => void;
}

export const useKeyPress = (keys: string | string[], options: IUseKeyPressOptions = {}) => {
  const normalizedKeys = Array.isArray(keys) ? keys : [keys];

  const [keyPressed, setKeyPressed] = useState<string | null>(null);

  useEffect(() => {
    const downHandler = (event: KeyboardEvent) => {
      if (normalizedKeys.includes(event.key)) {
        setKeyPressed(event.key);

        if (options.onDown) {
          options.onDown(event);
        }
      }
    };

    const upHandler = (event: KeyboardEvent) => {
      if (normalizedKeys.includes(event.key)) {
        setKeyPressed(null);
      }
    };

    if (!options.disabled) {
      window.addEventListener('keydown', downHandler);
      window.addEventListener('keyup', upHandler);
    } else {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);

      setKeyPressed(null);
    }

    return () => {
      window.removeEventListener('keydown', downHandler);
      window.removeEventListener('keyup', upHandler);
    };
  }, [normalizedKeys, options.disabled]);

  return !!keyPressed;
};
